import { readCartDesign, cartDesignSvg, changeCartQuantity } from './instant-film-mat-cart.js';

const hosts = [...document.querySelectorAll('.js-mini-cart-content')];
if (hosts.length) {
  const root = window.Shopify?.routes?.root || '/';
  let running = false, queued = false, removing = false, timer;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  };
  const money = (cents, currency) => {
    if (window.theme?.Currency?.formatMoney) return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
  };
  const editLink = key => root + 'pages/custom-mats?edit_mat=' + encodeURIComponent(key);
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(refresh, 60);
  });
  // Watch legacy list replacement, not currency-formatting inside our rows.
  const observe = () => hosts.forEach(host => observer.observe(host, { childList: true }));
  function renderItem(item, currency) {
    const saved = readCartDesign(item);
    const row = make('div', 'mini-cart-item');
    row.dataset.iffMiniKey = item.key;
    const image = make('a', 'mini-cart-image');
    image.href = saved ? editLink(item.key) : item.url;
    if (saved) image.innerHTML = cartDesignSvg(saved);
    else if (item.image) {
      const img = make('img', '');
      img.src = item.image; img.alt = item.product_title || item.title;
      image.append(img);
    } else image.append(make('span', 'small', 'No product image'));
    const meta = make('div', 'mini-cart-meta');
    const title = make('a', '', saved ? 'Custom Photo Mat' : item.title);
    title.href = image.href;
    const heading = make('p', ''); heading.append(title); meta.append(heading);
    if (saved) {
      const details = make('div', 'iff-mini-details');
      [
        `Film: ${saved.design.film.name}`,
        `Mat size: ${saved.design.width}" × ${saved.design.height}"`,
        `Windows: ${saved.design.windows}`,
        `Color: ${saved.color.name} (${saved.color.id})`
      ].forEach(text => details.append(make('span', '', text)));
      const edit = make('a', 'iff-cart-edit', 'Edit design');
      edit.href = editLink(item.key); details.append(edit); meta.append(details);
    }
    const price = make('span', '');
    price.innerHTML = money(item.final_price ?? item.price, currency);
    meta.append(price, make('b', '', ' × ' + item.quantity));
    const remove = make('button', 'btn iff-remove-mini-cart', '×');
    remove.type = 'button';
    remove.dataset.iffRemoveKey = item.key;
    remove.setAttribute('aria-label', 'Remove ' + (saved ? 'custom photo mat' : item.product_title || item.title));
    row.append(image, meta, remove);
    return row;
  }
  async function refresh() {
    if (running) { queued = true; return; }
    running = true;
    try {
      const response = await fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Your cart preview could not load.');
      const cart = await response.json();
      observer.disconnect();
      hosts.forEach(host => {
        host.dataset.iffMiniReady = 'true';
        const rows = cart.items.slice(0, 5).map(item => renderItem(item, cart.currency));
        if (!rows.length) rows.push(make('p', 'alert', 'Your cart is empty.'));
        if (cart.items.length > 5) {
          const more = make('a', 'js-btn-viewmore', 'View all cart items'); more.href = root + 'cart'; rows.push(more);
        }
        host.replaceChildren(...rows);
      });
      document.querySelectorAll('.js-cart-count').forEach(node => { node.textContent = cart.item_count; });
      document.querySelectorAll('.js-cart-total').forEach(node => { node.innerHTML = money(cart.total_price, cart.currency); });
      document.querySelectorAll('.js-cart-btn-checkout').forEach(node => {
        node.classList.toggle('disabled', !cart.item_count);
        node.setAttribute('aria-disabled', String(!cart.item_count));
      });
    } catch (error) {
      hosts.forEach(host => {
        const message = make('p', 'iff-mini-error', 'Your cart is saved. Preview unavailable—view your cart to review your design.');
        const link = make('a', '', 'View cart'); link.href = root + 'cart'; message.append(' ', link);
        observer.disconnect(); host.replaceChildren(message);
      });
      console.warn(error);
    } finally {
      observe(); running = false;
      if (queued) { queued = false; refresh(); }
    }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-iff-remove-key]');
    if (!button || removing) return;
    event.preventDefault();
    removing = true; button.disabled = true;
    const host = button.closest('.js-mini-cart-content') || hosts[0];
    try {
      await changeCartQuantity({ root, key: button.dataset.iffRemoveKey, quantity: 0 });
      // The full cart must also update if its header dropdown is used there.
      if (document.querySelector('[data-iff-cart-root]')) window.location.reload();
      else await refresh();
    } catch (error) {
      const message = make('p', 'iff-mini-error', error.message + ' Refresh your cart before retrying if the update could not be confirmed.');
      message.setAttribute('role', 'status');
      observer.disconnect(); host.append(message); observe();
      button.disabled = false;
    } finally { removing = false; }
  });
  observe();
  refresh();
}
